import { useEffect, useRef, useState } from "react";

/**
 * Die zulässigen Länderkürzel aus `GET /api/laender` (Spec „Adresszeile", R17) — web darf
 * domain nicht importieren, und eine abgetippte Liste veraltete mit dem nächsten Land still.
 * Scheitert das Laden oder fehlt die Methode (Test-Attrappe), bleibt die Liste leer; die
 * Ortszeile zeigt dann nur den gespeicherten Wert — gespeichert werden kann weiterhin.
 *
 * Geladen wird einmal je Einbau, nicht je Aufruf-Identität: eine Pfeilfunktion im Aufruf wäre
 * sonst bei jeder Zeichnung neu, löste das Laden erneut aus und hielte die Zeichnung am Laufen.
 */
export function useLaender(
  listLaender: (() => Promise<{ laender: string[] }>) | undefined,
): string[] {
  const [laender, setLaender] = useState<string[]>([]);
  const lade = useRef(listLaender);
  lade.current = listLaender;
  const vorhanden = listLaender !== undefined;
  useEffect(() => {
    if (!vorhanden) return;
    let abgebrochen = false;
    Promise.resolve()
      .then(() => lade.current?.())
      .then((antwort) => { if (!abgebrochen && antwort !== undefined) setLaender(antwort.laender); })
      .catch(() => { /* Rückfall: nur der gespeicherte Wert */ });
    return () => { abgebrochen = true; };
  }, [vorhanden]);
  return laender;
}
